import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/src/node_modules/.pnpm/next@15.3.8_@babel+core@7.26.10_babel-plugin-macros@3.1.0_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.87.0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/klarna/components/faq.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/klarna/components/klarna_DE.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/Image/index.tsx");
